<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</div>


<div class="table-container">
  <body>
    <div *ngIf="usuarioLogado">
      <button mat-button [disabled]="usuarioLogado.role != '9' && usuarioLogado.role != '2' && usuarioLogado.role != '10'" (click)="editDialog('')">
        <span class="material-icons">note_add</span> Adicionar Fornecedor
      </button>
    </div>
    <ul>
      <div class="table">
        <table class="tableFlex">
          <thead>
            <tr class="trFlex">
              <th>Place</th>
              <th>Nome contato</th>
              <th class="flex2">e-mail</th>
              <th>Telefone</th>
              <th>Endereço</th>
              <th>Local Descarga</th>
              <th>Latitude</th>
              <th>Longitude</th>
              <th class="flex05">Local de Descarga?</th>
              <th class="flex05">Action</th>
            </tr>
          </thead>
          <tbody *ngFor="let item of items">
            <tr class="trFlex">
              <td>{{ item.local }}</td>
              <td>{{ item.nomeContato }}</td>
              <td class="flex2">{{ item.contato }}</td>
              <td>{{ item.telefone }}</td>
              <td>{{ item.endereco }}</td>
              <td>{{ item.localDescarga }}</td>
              <td>{{ item.latitude }}</td>
              <td>{{ item.longitude }}</td>
              <td class="flex05">{{ item.descarga }}</td>
              <td class="flex05">
                <button mat-icon-button color="primary"
                  [disabled]="usuarioLogado.role != '9' && usuarioLogado.role != '2' && usuarioLogado.role != '10'" aria-label="Editar"
                  (click)="editDialog(item)">
                  <span class="material-icons">edit</span>
                </button>
                <button [disabled]="usuarioLogado.role != '9' && usuarioLogado.role != '2'" mat-icon-button color="warn"
                  aria-label="Excluir" (click)="deleteItem(item.ID, urlConsulta, query)">
                  <span class="material-icons">delete</span>
                </button>
                <!-- <i-feather name="edit" (click)="editDialog(item)"></i-feather> -->
                <!-- <span style="margin-left: 10px; margin-right: 10px;"></span>
                <i-feather name="delete" (click)="deleteItem(item.ID, urlConsulta, query)"
                  class="button-spacing"></i-feather> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ul>
  </body>

</div>

<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'sm'" class="dialog-container">
  <h2 class="modal-title">Adicionar Fornecedor</h2>
  <div class="modal-body">
    <form class="inputs">
      <div>
        <label class="modal-label">Fornecedor</label>
        <input type="string" name="fornecedor" [(ngModel)]="item.local" class="modal-input1" (blur)="onFieldTouched()">
        <div *ngIf="campoTocado && (item.local == null || item.local == undefined || item.local == '')">
          <small class="text-danger">Required</small>
        </div>
      </div>
      <div>
        <label class="modal-label">Nome Contato</label>
        <input type="string" name="nomeContato" [(ngModel)]="item.nomeContato" class="modal-input1">
      </div>
      <div>
        <label class="modal-label">e-mail</label>
        <input type="string" name="email" [(ngModel)]="item.contato" class="modal-input1">
      </div>
      <div>
        <label class="modal-label">Telefone</label>
        <input type="string" name="telefone" [(ngModel)]="item.telefone" class="modal-input1">
      </div>
      <div>
        <label class="modal-label">Endereço</label>
        <input type="string" name="endereco" [(ngModel)]="item.endereco" class="modal-input1">
      </div>
      <div>
        <label class="modal-label">Locais de descarga</label>
        <input type="string" name="localDescarga" [(ngModel)]="item.localDescarga" class="modal-input1">
      </div>
      <div>
        <label class="modal-label">Latitude</label>
        <input type="string" name="latitude" [(ngModel)]="item.latitude" class="modal-input1" (blur)="onFieldTouched()">
        <div *ngIf="campoTocado && (item.latitude == null || item.latitude == undefined || item.latitude == '')">
          <small class="text-danger">Required</small>
        </div>
        <label class="modal-label">Longitude</label>
        <input type="string" name="logitude" [(ngModel)]="item.longitude" class="modal-input1"
          (blur)="onFieldTouched()">
        <div *ngIf="campoTocado && (item.longitude == null || item.longitude == undefined || item.longitude == '')">
          <small class="text-danger">Required</small>
        </div>
      </div>

      <div>
        <label class="modal-label">Local de Descarga?</label>
        <input type="checkbox" id="descarga" name="descarga" [(ngModel)]="item.descarga">
      </div>

      <div class="modal-div">
        <button class="modal-button" type="button" (click)="salvar()">Save</button>
        <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</clr-modal>